module.exports = __webpack_public_path__ + "img/kt-gfk.a620a285.png";